// Estilos compartidos de las piezas del documento al cliente (F4b · D). Sólo presentación.
import type { CSSProperties } from 'react';

export const caja: CSSProperties = {
  padding: 14,
  background: 'hsl(var(--card))',
  border: '1px solid hsl(var(--border))',
  borderRadius: 8,
  marginBottom: 14,
};

export const tituloDeCaja: CSSProperties = {
  margin: '0 0 10px',
  fontSize: 14,
  fontWeight: 600,
  color: 'hsl(var(--foreground))',
};

export const ayuda: CSSProperties = {
  fontSize: 12,
  color: 'hsl(var(--muted-foreground))',
  marginTop: 4,
};

export const enlace: CSSProperties = {
  background: 'none',
  border: 'none',
  color: 'hsl(var(--primary))',
  fontSize: 12,
  textDecoration: 'underline',
  cursor: 'pointer',
  padding: 0,
};

export const botonChico: CSSProperties = {
  border: '1px solid hsl(var(--muted-foreground) / 0.4)',
  background: 'hsl(var(--card))',
  borderRadius: 6,
  fontSize: 12,
  padding: '3px 8px',
  cursor: 'pointer',
  color: 'hsl(var(--foreground))',
};

export const aviso: CSSProperties = { fontSize: 12, color: 'hsl(var(--alerta))', marginTop: 4 };
export const error: CSSProperties = { fontSize: 12, color: 'hsl(var(--bloqueo))', marginTop: 4 };
